import { css, Theme } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const InputPasswordStyle = {
  self: ({ colors }: Theme) => css`
    &.ant-input,
    .ant-input {
      font-size: 14px;
      color: ${theme.colors.lightText};
      font-weight: 500;
      background: transparent;
      &::placeholder {
        color: ${theme.colors.lightText};
        opacity: 0.6;
      }
    }

    &.ant-input-affix-wrapper,
    .ant-input-affix-wrapper {
      width: 100%;
      height: 44px;
      border: 1px solid ${theme.borders.secondary};
      padding: 5px 10px;
      background-color: transparent;
      border-radius: 8px;
      outline: none;
      box-shadow: none;

      ${media["2sm"]} {
        display: flex;
        flex-direction: row;
        align-items: center;
        input {
          width: 100%;
          outline: none;
          box-shadow: none;
          height: 34px;
          border: 0px;
        }
      }

      input:-webkit-autofill {
        -webkit-background-clip: text;
        -webkit-text-fill-color: ${theme.colors.lightText};
      }

      .ant-input-suffix {
        svg {
          color: ${theme.colors.lightText};
        }
      }

      &:focus,
      &:hover {
        border-color: ${theme.borders.tertiary};
        &:-webkit-autofill {
          -webkit-background-clip: text;
          -webkit-text-fill-color: ${theme.colors.lightText};
        }
      }
      &-disabled {
        opacity: 0.8;
        background: #363636;
      }

      &-status-error {
        border-color: var(--error-color) !important;
        input::placeholder {
          color: var(--error-color);
        }
        .ant-input-suffix {
          svg {
            color: var(--error-color);
          }
        }
      }
    }
    & .ant-form-item-explain-error {
      color: var(--error-color) !important;
    }
  `,
};
